/**
 * Pinia
 *
 * @library
 *
 * https://pinia.vuejs.org/
 */

// Lib imports
import {defineStore} from "pinia";

// Store functionality
import actions from './actions'
import getters from './getters'
import state from './state'


// Create a new store
const useModuleStore = defineStore('moduleStore',{
  actions,
  getters,
  state
});

export default useModuleStore
